import { useEffect, useState } from "react";
import { useCart } from "contexts/cart-context";
import * as S from "./vaiustyles";
import { payment } from "services/payment";
//import swal from "sweetalert";
//import PinInput from "react-pin-input";
import VaiuCodeInput from "./VaiuCodeInput";
import QRCodeScanner from 'components/Vaiu/QRCodeScanner';
import VaiuIFrame from 'components/Vaiu/VaiuIFrame';
import QRCodeDisplay from 'components/Vaiu/QRCodeDisplay';
import { isTemplateLiteralToken } from "typescript";

type IEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>;

const vaiu_pay_urls: { [key: string]: string } = {};
const vaiu_checkuser_urls: { [key: string]: string } = {};
vaiu_pay_urls["prod"] = "https://vaiu.app/pay?";
vaiu_pay_urls["stage"] = "https://vaiu.app/pay?";
vaiu_pay_urls["local"] = "http://localhost:3000/pay?";

vaiu_checkuser_urls["prod"] = "https://vaiu.app/uiapi?get=username";
vaiu_checkuser_urls["stage"] = "https://vaiu.app/uiapi?get=username";
vaiu_checkuser_urls["local"] = "http://localhost:3000/uiapi?get=username";

const env = "prod"; // prod, stage, local
const VAIU_PAY_URL = vaiu_pay_urls[env];
const VAIU_CHECKUSER_URL = vaiu_checkuser_urls[env];

console.log("VAIU_PAY_URL: ", VAIU_PAY_URL);
console.log("VAIU_CHECKUSER_URL: ", VAIU_CHECKUSER_URL);

export interface VaiuResult {
  // Define the properties of the result object here
  amount:number;
}

export interface VaiuError {
  // Define the properties of the error object here
  message:string;
}
interface VaiuCheckoutProps {
  amount: number;
  onResult: (result:VaiuResult,error:VaiuError) => void; // Adjust this to the actual function signature
  demo: number;
}


const VaiuCheckout: React.FC<VaiuCheckoutProps> = ({ amount, onResult, demo }) => {
  const { products, total, isOpen, openCart, closeCart } = useCart();

  const [working, setWorking] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [showScanner, setShowScanner] = useState<boolean>(false);
  const [showVaiu, setShowVaiu] = useState<boolean>(false);
  const [showCodeInput, setShowCodeInput] = useState<boolean>(false);
  const [pinCode, setPinCode] = useState<string>("");
  const [btnIsPressed, setBtnIsPressed] = useState<boolean>(false);
  const [processingStep, setProcessingStep] = useState<string>("Processing Payment");
  const [iframeheight, setIframeHeight] = useState<number>(0);
  const [autoCreate, setAutoCreate] = useState<string>("");
  const [tokenMessage, setTokenMessage] = useState<string>("");

  // we will use a hack!!
  // iframeheight is set to 1 to check if a user is logged in
  // if a user is logged in, then set ifraemheight to 0 for the auto-generated token demo
  // if a user is not logged in, then set iframeheight to 500 for the manual token entry demo

  useEffect(() => {
    setupForDemo(demo);
  }, [demo]);

  useEffect(() => {
    // set the token message to the stringified products in the cart
    // URL encode the stringified products
    //setTokenMessage(encodeURIComponent(JSON.stringify(products)));
    if (products.length > 0) {
      // create a string of lines with product name and quantity
      let productString = "";
      products.forEach((product) => {
        productString += product.title + " x " + product.quantity + "\n";
      });
      setTokenMessage(encodeURIComponent(productString));
    }
  }, [products]);


  useEffect(() => {
    return () => {
      // Perform cleanup activities here
      setShowScanner(false);
      setShowVaiu(false);
      setShowCodeInput(false);
      setWorking(false);
      setAutoCreate("autoPay=true&ptp=true&need=deliveryAddress");
      setIframeHeight(0);
      setupForDemo(demo);
    };
  }, []);

  // monitor the state of showVaiu
  // when it is true, set the processing step to "Processing Payment"
  useEffect(() => {
    if (showVaiu) {
      setProcessingStep("Generating a cash token...");
    }
  }, [showVaiu]);

  // useEffect(() => {
  //   if (pinCode.length >= 6) {
  //     doTheCheckout();
  //   }
  // }, [pinCode]);

  //use useEffect to check that btnIsPressed is true, if so, call doTheCheckout
  useEffect(() => {
    if (btnIsPressed) {
      setProcessingStep("Processing cash token...");
      doTheCheckout();
    }
  }, [btnIsPressed]);


  // use useEffect to check for a message from the embedded iframe
  // the message will be an object with {type:"vaiu", token: "token"}
  // listen for a message from the iframe
  // if the message is from vaiu, then set the pinCode to the token in the message
  // then call doTheCheckout()
  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.data.type === "vaiu") {
        console.log("got message from iframe", event.data.token);
        if (event.data.token) {
          setPinCode(event.data.token);
          setBtnIsPressed(true);
        }
        else {
          if ((!event.data?.username) || event.data.username.length == 0) {
            setIframeHeight(500);
            setProcessingStep("Please login. Then, try paying again.");
            console.log("VAIUCHECKOUT UIAPI check: user is NOT logged in");
          } else {
            console.log("got username from iframe", event.data.username);
            setIframeHeight(0);
            console.log("VAIUCHECKOUT UIAPI check: user is logged in");
          }
        }
        if (event.data.message) {
          setProcessingStep(event.data.message);
        }
      }
    };
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    };
  }, []);

  const setupForDemo = (demo: number) => {
    if (demo ===1) {
      // this is a demo of automatically creating the token and applying it to the payment
      // for the full value of the cart.
      setShowScanner(false);
      setShowVaiu(true);  
      setShowCodeInput(false);
      setWorking(true);
      setIframeHeight(1); //hack to first check if user is logged in
      setAutoCreate("autoPay=true&ptp=true");
    }
    if ( demo === 2 ) {
      // this is a demo of manually entering the token
      setShowScanner(false);
      setShowVaiu(false);  
      setShowCodeInput(true);
      setIframeHeight(500);
      setAutoCreate("");
    }
    if ( demo === 3 ) {
      // this is a demo of scanning the token
      setShowScanner(true);
      setShowVaiu(false);  
      setShowCodeInput(false);
      setAutoCreate("");
      setIframeHeight(0);
    }
    if ( demo === 4 ) {
      // this is a demo of embedded app, manually create token
      setShowScanner(false);
      setShowVaiu(true);  
      setShowCodeInput(false);
      setAutoCreate("ptp=true");
      setIframeHeight(500);
    }
  }

  const showVaiuApp = () => {
    setShowVaiu(true);
    setShowScanner(false);
  } 
  
  // const turnOnScanner = () => {
  //   setShowScanner(true);
  //   setShowVaiu(false);
  // }

  const handleCheckout = (event: IEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setBtnIsPressed(true);
  }

  const doTheCheckoutFromScanner = async (valueFromQRScanner:string) => {
    // get the code as the last 6 characters from the value from the QR Code scanner
    // set the pinCode to the code
    // call doTheCheckout
    const code = valueFromQRScanner.slice(-6);

    setPinCode(code);
    setBtnIsPressed(true);
  }

  const randomOrderId = () => {
    // come up with a random order id that is based on the current time
    const now = new Date();
    const orderId = now.getFullYear().toString() + now.getMonth().toString() + now.getDate().toString() + now.getHours().toString() + now.getMinutes().toString() + now.getSeconds().toString();
    return orderId;
  }

  const initPay = async () => {
    //Set Pay
    //alert("processing code " + pinCode );
    setProcessingStep("Applying cash token [ " + pinCode + " ] to payment");
    const orderData = {"id": randomOrderId(), "products": products, "total": total};
    console.log("going to pay with orderData: ", orderData);
    const pay = await payment(pinCode, orderData);
    const { amount, errorMessage } = pay;
    let result :VaiuResult = { amount };
    let error : any = null;
    if ( errorMessage ) {
      error = {message: errorMessage};
    }
    if ( !errorMessage) {
      setSuccess(true);
      setWorking(false);
      setProcessingStep("done.");

    }
    onResult(result,error);
  };

  const doTheCheckout = async () => {
    const pinValid: boolean = pinCode.length >= 6;

    console.log("doTheCheckout: pinValid: ", pinValid);
    console.log("pinCode: ", pinCode);
    setWorking(true);
    //setBtnIsPressed(false);
    if (total.productQuantity && pinValid ) {
      return initPay();
    }
    // if (total.productQuantity == 0) {
    //   return showAlert("You need to add a product to the shopping cart");
    // }
  //   if (!pinValid) {
  //     return showAlert("The vaiu code is not correct");
  //   }
 };



  const handlePinChange = (thePinCode: string) => {
      setPinCode(thePinCode);
      //setBtnIsPressed(false);
    };

  // const handlePinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const thePinCode = event.target.value;
  //   setPinCode(thePinCode);
  //   //setBtnIsPressed(false);
  // };

  return (
    <div>

{success && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            flexDirection: "column",
          }}
        >
          <div className="SucessContainer">
            <div className="w3-modal-icon w3-modal-success animate">
              <span className="w3-modal-line w3-modal-tip animateSuccessTip"></span>
              <span className="w3-modal-line w3-modal-long animateSuccessLong"></span>
              <div className="w3-modal-placeholder"></div>
              <div className="w3-modal-fix"></div>
            </div>
          </div>
          <p style={{ color: "white", fontWeight: "bold" }}>Successful</p>
        </div>
      )}
      {working && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            flexDirection: "column",
          }}
        >
          <div className="SucessContainer">
            <div className="w3-modal-icon w3-modal-success animate">
              <div className="w3-modal-placeholder"></div>
              <div className="w3-modal-fix"></div>
            </div>
          </div>
          <p style={{ color: "white", fontWeight: "bold" }}>{processingStep}</p>
        </div>
      )}
      {showVaiu ? (
        <S.VaiuIFrameContainer style={{height: iframeheight+"px"}}>
          {iframeheight == 1 ? (
            <VaiuIFrame src={VAIU_CHECKUSER_URL} amount={amount} title="Vaiu Checkout" scale={0.6}/>
          ) : (
          <VaiuIFrame src={VAIU_PAY_URL +autoCreate+"&amount=" + amount+"&message="+tokenMessage+"&embed=true"} amount={amount} title="Vaiu Checkout" scale={0.6}/>
          )}
        </S.VaiuIFrameContainer>
      ) :
      (
        <S.CheckoutButton style={{fontSize:'10px'}} onClick={showVaiuApp}>
        (show Vaiu App)
      </S.CheckoutButton>
      )
      }
      { showCodeInput && (
        <>
      <S.Pins>
        <QRCodeDisplay value={VAIU_PAY_URL + "amount=" + amount+"&message="+tokenMessage} />
        <VaiuCodeInput onCompleted={handlePinChange}/>
        {/*
        <input 
        type="text" 
        maxLength={6} 
        placeholder="▯▯▯▯▯▯" 
        onChange={handlePinChange}
        style={{ color: "white", fontFamily: 'monospace', marginTop: "20px" }}
      />
      */}
      </S.Pins>
      <S.CheckoutButton onClick={handleCheckout}>
        Enter Payment Code
      </S.CheckoutButton>
      </>
      )}
      {showScanner && (
        <S.QRScanner>
          <QRCodeScanner onScanComplete={doTheCheckoutFromScanner} />
        </S.QRScanner>
      ) }

    </div>
  );
};

export default VaiuCheckout;
